import { render, staticRenderFns } from "./AddNewPayService.vue?vue&type=template&id=15b7f018&scoped=true"
import script from "./AddNewPayService.vue?vue&type=script&lang=ts"
export * from "./AddNewPayService.vue?vue&type=script&lang=ts"
import style0 from "./AddNewPayService.vue?vue&type=style&index=0&id=15b7f018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b7f018",
  null
  
)

export default component.exports